/**
 * Language registry – one translation file per language.
 *
 * HOW TO ADD A NEW LANGUAGE
 * -------------------------
 * 1. Add the flag asset to `src/assets/icons/flags/` and import it below.
 * 2. Add the language code to `LanguageCode`.
 * 3. Create `src/translations/<code>.ts` – copy `hu.ts` as a starting point and
 *    translate. It is typed against the English catalogue, so keys are checked
 *    at compile time and anything you leave out falls back to English.
 * 4. Import that file and add it to `LANGUAGES` and `translations` below.
 *
 * The header language selector is driven by `LANGUAGES`, so the new language
 * appears in the UI as soon as it is registered here.
 */

import enFlag from 'assets/icons/flags/en_flag.svg'
import huFlag from 'assets/icons/flags/hu_flag.svg'
import en, { Translation } from './en'
import hu from './hu'

export type { Translation }

export type LanguageCode = 'en' | 'hu'

export const DEFAULT_LANGUAGE: LanguageCode = 'en'

export type Language = {
    code: LanguageCode
    name: string
    shortName: string
    flag: string
}

export const LANGUAGES: Array<Language> = [
    { code: 'en', name: 'English', shortName: 'EN', flag: enFlag },
    { code: 'hu', name: 'Magyar', shortName: 'HU', flag: huFlag }
]

const translations: Record<LanguageCode, Translation> = {
    en,
    hu
}

export default translations
